export enum UserRoles {
    Admin = "Admin",
    Operador = "Operador"
}
